import type { BariPreGroupSessionData } from '@common/validation/customControls/bariPre/bariPreGroupSession/v1/bariPreGroupSessionSchemaV1';

export const initialData: BariPreGroupSessionData = {
    aanwezigheid: null,
    datum_en_tijd: null,
};
